import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import Spinner from "react-bootstrap/Spinner";
import config from "../../Config";
import FeeSystemMenu from "./FeeSystemMenu";
import moment from "moment";

const REFERENCE_TYPES = ["Monthly", "Admission", "Advance", "Installment", ""];

const COLUMNS = [
  { key: "FeeCode", label: "Fee Code", type: "fee" },
  { key: "Description", label: "Description", type: "text" },
  { key: "Reference_ID_Type", label: "Reference Type", type: "ref" },
  { key: "Fee_Posted", label: "Fee Posted", type: "number" },
  { key: "ConcessionCode", label: "Concession Code", type: "concession" },
  { key: "ConcessionAmount", label: "Concession Amount", type: "number" },
  { key: "LeftAmount", label: "Left Amount", type: "number" },
  { key: "ReceiveableFee", label: "Receiveable Fee", type: "number" },
  { key: "ReceivedAmount", label: "Received Amount", type: "number" },
  { key: "PendingFee", label: "Pending Fee", type: "number" },
  { key: "ReceivedDate", label: "Received Date", type: "date" },
  { key: "AdvanceAdjusted", label: "Advance Adjusted", type: "number" },
  { key: "AdvanceChallanNo", label: "Advance Challan No", type: "text" },
  { key: "AdvancePaymentID", label: "Advance Payment ID", type: "int" },
  { key: "AdjustmentDate", label: "Adjustment Date", type: "date" },
  { key: "Arrears", label: "Arrears", type: "number" },
];

const emptyRow = () => ({
  ID: 0,
  FeeCode: "",
  Description: "",
  Reference_ID_Type: "Monthly",
  Fee_Posted: 0,
  ConcessionCode: "",
  ConcessionAmount: 0,
  LeftAmount: 0,
  ReceiveableFee: 0,
  ReceivedAmount: 0,
  PendingFee: 0,
  ReceivedDate: null,
  AdvanceAdjusted: null,
  AdvanceChallanNo: "",
  AdvancePaymentID: null,
  AdjustmentDate: null,
  Arrears: 0,
  Is_Deleted: false,
});

const formatDisplay = (row, key) => {
  const val = row[key];
  if (val === null || val === undefined || val === "") return "—";
  if (key === "ReceivedDate" || key === "AdjustmentDate") {
    return moment(val).isValid() ? moment(val).format("DD/MM/YYYY") : "—";
  }
  return val;
};

const toDateInput = (val) => {
  if (!val) return "";
  const m = moment(val);
  return m.isValid() ? m.format("YYYY-MM-DD") : "";
};

const AdminEditChallan = () => {
  const [AccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID] = useState(localStorage.getItem("ID"));
  const [MemberType] = useState(localStorage.getItem("MemberType"));
  const [UserName] = useState(localStorage.getItem("UserName") || "");

  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const initialChallan =
    params.get("ChallanNo") || params.get("challanNo") || params.get("Challan_No") || "";

  const [searchChallanNo, setSearchChallanNo] = useState(initialChallan);
  const [activeChallanNo, setActiveChallanNo] = useState("");
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [challan, setChallan] = useState(null);
  const [originalItems, setOriginalItems] = useState([]);
  const [items, setItems] = useState([]);
  const [feeTypes, setFeeTypes] = useState([]);
  const [concessionRules, setConcessionRules] = useState([]);
  const [dueDate, setDueDate] = useState("");
  const [afterDueDate, setAfterDueDate] = useState("");
  const [ledgerTotal, setLedgerTotal] = useState(0);

  useEffect(() => {
    document.title = "Admin Edit Challan";
  }, []);

  useEffect(() => {
    const apiData = {
      AccessKey,
      UserID,
      MemberType,
      pageNo: 1,
      pageSize: 500,
      SchoolID: 1,
    };

    axios({
      method: "post",
      url: config.base_url + "FeeType/GetFeeTypes",
      headers: { "Content-Type": "application/json" },
      data: apiData,
    })
      .then((res) => setFeeTypes(res.data.ListofRecords || []))
      .catch(() => {});

    axios({
      method: "post",
      url: config.base_url + "Concession/GetConcessionRules",
      headers: { "Content-Type": "application/json" },
      data: { ...apiData, pageSize: 1000 },
    })
      .then((res) => setConcessionRules(res.data.ListofRecords || []))
      .catch(() => {});
  }, [AccessKey, UserID, MemberType]);

  const loadChallan = (challanNo) => {
    const no = (challanNo || "").trim();
    if (!no) {
      toast.error("Enter a challan number.", { position: toast.POSITION.TOP_RIGHT });
      return;
    }

    setLoading(true);
    setChallan(null);
    setOriginalItems([]);
    setItems([]);

    axios({
      method: "post",
      url: config.base_url + "ADLedger/GetChallanForAdminEdit",
      headers: { "Content-Type": "application/json" },
      data: {
        AccessKey,
        UserID: parseInt(UserID, 10) || 0,
        MemberType,
        Challan_No: no,
      },
    })
      .then((response) => {
        if (response.data.status_code === 1) {
          const loaded = response.data.Items || [];
          setChallan(response.data.Challan);
          setOriginalItems(loaded);
          setItems(loaded.map((row) => ({ ...row, Is_Deleted: false })));
          setLedgerTotal(response.data.LedgerTotal || 0);
          setActiveChallanNo(no);
          if (response.data.Challan?.Due_Date) {
            setDueDate(response.data.Challan.Due_Date.substring(0, 10));
          }
          if (response.data.Challan?.After_Due_Date) {
            setAfterDueDate(response.data.Challan.After_Due_Date.substring(0, 10));
          }
          if (!response.data.HeadMatchesLedger) {
            toast.warn(
              "Challan head total does not match ledger sum. Saving will sync head totals from ledger.",
              { position: toast.POSITION.TOP_RIGHT, autoClose: 8000 }
            );
          }
        } else {
          toast.error(response.data.status_message || "Challan not found.", {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      })
      .catch(() => {
        toast.error("Network error.", { position: toast.POSITION.TOP_RIGHT });
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    if (initialChallan.trim()) {
      loadChallan(initialChallan.trim());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSearch = (e) => {
    e.preventDefault();
    loadChallan(searchChallanNo);
  };

  const handleItemChange = (index, field, value) => {
    setItems((prev) =>
      prev.map((row, i) => (i === index ? { ...row, [field]: value } : row))
    );
  };

  const handleFeeCodeChange = (index, value) => {
    const fee = feeTypes.find((ft) => String(ft.Fee_Type_Code) === String(value));
    setItems((prev) =>
      prev.map((row, i) =>
        i === index
          ? {
              ...row,
              FeeCode: value,
              Description: fee ? fee.Fee_Type_Name : row.Description,
            }
          : row
      )
    );
  };

  const handleAddRow = () => {
    setItems((prev) => [...prev, emptyRow()]);
  };

  const handleRemoveRow = (index) => {
    setItems((prev) => {
      const row = prev[index];
      if (row?.ID > 0) {
        return prev.map((r, i) => (i === index ? { ...r, Is_Deleted: true } : r));
      }
      return prev.filter((_, i) => i !== index);
    });
  };

  const activeItems = items.filter((row) => !row.Is_Deleted);
  const editTotal = activeItems.reduce(
    (sum, row) => sum + (parseFloat(row.ReceiveableFee) || 0),
    0
  );

  const handleSave = () => {
    if (!activeChallanNo) return;

    const payloadItems = items
      .filter((row) => row.ID > 0 || (!row.Is_Deleted && (row.FeeCode || "").trim()))
      .map((row) => ({
        ID: row.ID || 0,
        FeeCode: (row.FeeCode || "").trim(),
        Description: row.Description || "",
        Reference_ID_Type: row.Reference_ID_Type || "",
        Fee_Posted: parseFloat(row.Fee_Posted) || 0,
        ConcessionCode: row.ConcessionCode || "",
        ConcessionAmount: parseFloat(row.ConcessionAmount) || 0,
        LeftAmount: parseFloat(row.LeftAmount) || 0,
        ReceiveableFee: parseFloat(row.ReceiveableFee) || 0,
        ReceivedAmount: parseFloat(row.ReceivedAmount) || 0,
        PendingFee: parseFloat(row.PendingFee) || 0,
        ReceivedDate: row.ReceivedDate ? `${toDateInput(row.ReceivedDate)}T00:00:00` : null,
        AdvanceAdjusted:
          row.AdvanceAdjusted === "" || row.AdvanceAdjusted === null
            ? null
            : parseFloat(row.AdvanceAdjusted) || 0,
        AdvanceChallanNo: row.AdvanceChallanNo || "",
        AdvancePaymentID:
          row.AdvancePaymentID === "" || row.AdvancePaymentID === null
            ? null
            : parseInt(row.AdvancePaymentID, 10) || null,
        AdjustmentDate: row.AdjustmentDate ? `${toDateInput(row.AdjustmentDate)}T00:00:00` : null,
        Arrears: parseFloat(row.Arrears) || 0,
        Is_Deleted: !!row.Is_Deleted,
      }));

    setSaving(true);
    axios({
      method: "post",
      url: config.base_url + "ADLedger/UpdateChallanForAdminEdit",
      headers: { "Content-Type": "application/json" },
      data: {
        AccessKey,
        UserID: parseInt(UserID, 10) || 0,
        MemberType,
        UserName,
        Challan_No: activeChallanNo,
        Due_Date: dueDate ? `${dueDate}T00:00:00` : null,
        After_Due_Date: afterDueDate ? `${afterDueDate}T00:00:00` : null,
        Items: payloadItems,
      },
    })
      .then((response) => {
        if (response.data.status_code === 1) {
          toast.success(response.data.status_message, { position: toast.POSITION.TOP_RIGHT });
          loadChallan(activeChallanNo);
        } else {
          toast.error(response.data.status_message || "Save failed.", {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      })
      .catch(() => {
        toast.error("Network error.", { position: toast.POSITION.TOP_RIGHT });
      })
      .finally(() => setSaving(false));
  };

  const renderEditCell = (row, index, col) => {
    const key = col.key;
    if (col.type === "fee") {
      return (
        <select
          className="form-select form-select-sm"
          value={row.FeeCode || ""}
          onChange={(e) => handleFeeCodeChange(index, e.target.value)}
        >
          <option value="">Select</option>
          {feeTypes.map((ft) => (
            <option key={ft.Fee_Type_ID} value={ft.Fee_Type_Code}>
              {ft.Fee_Type_Code} - {ft.Fee_Type_Name}
            </option>
          ))}
        </select>
      );
    }
    if (col.type === "concession") {
      return (
        <select
          className="form-select form-select-sm"
          value={row.ConcessionCode || ""}
          onChange={(e) => handleItemChange(index, "ConcessionCode", e.target.value)}
        >
          <option value="">—</option>
          {concessionRules.map((cr) => (
            <option key={cr.Concession_Rule_ID} value={cr.Concession_Rule_Code}>
              {cr.Concession_Rule_Code} - {cr.Concession_Rule_Name}
            </option>
          ))}
        </select>
      );
    }
    if (col.type === "ref") {
      return (
        <select
          className="form-select form-select-sm"
          value={row.Reference_ID_Type || ""}
          onChange={(e) => handleItemChange(index, "Reference_ID_Type", e.target.value)}
        >
          {REFERENCE_TYPES.map((rt) => (
            <option key={rt || "blank"} value={rt}>
              {rt || "—"}
            </option>
          ))}
        </select>
      );
    }
    if (col.type === "date") {
      return (
        <input
          type="date"
          className="form-control form-control-sm"
          value={toDateInput(row[key])}
          onChange={(e) =>
            handleItemChange(index, key, e.target.value ? e.target.value : null)
          }
        />
      );
    }
    if (col.type === "int") {
      return (
        <input
          type="number"
          className="form-control form-control-sm"
          value={row[key] ?? ""}
          onChange={(e) =>
            handleItemChange(
              index,
              key,
              e.target.value === "" ? null : parseInt(e.target.value, 10)
            )
          }
        />
      );
    }
    if (col.type === "number") {
      return (
        <input
          type="number"
          step="any"
          className="form-control form-control-sm"
          value={row[key] ?? 0}
          onChange={(e) => handleItemChange(index, key, e.target.value)}
        />
      );
    }
    return (
      <input
        type="text"
        className="form-control form-control-sm"
        value={row[key] || ""}
        onChange={(e) => handleItemChange(index, key, e.target.value)}
      />
    );
  };

  return (
    <>
      <FeeSystemMenu />
      <ToastContainer />
      <div className="page-head">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-8">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/Dashboard">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="/FeeSystem/PrintVouchers">Print Vouchers</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Admin Edit Challan
                  </li>
                </ol>
              </nav>
              <div className="page-title">Admin Edit Challan</div>
              <p className="text-muted small mb-0">
                Search by challan number and edit all ledger fields directly. Head
                totals sync from Receiveable Fee sum on save.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="page-content">
        <div className="container">
          <div className="card mb-3">
            <div className="card-body">
              <form className="row g-2 align-items-end" onSubmit={handleSearch}>
                <div className="col-md-4">
                  <label className="form-label">Challan number</label>
                  <input
                    className="form-control"
                    value={searchChallanNo}
                    onChange={(e) => setSearchChallanNo(e.target.value)}
                    placeholder="e.g. 2606014587"
                  />
                </div>
                <div className="col-md-2">
                  <button
                    type="submit"
                    className="button button-primary w-100"
                    disabled={loading}
                  >
                    {loading ? "Loading…" : "Search"}
                  </button>
                </div>
              </form>
            </div>
          </div>

          {loading ? (
            <div className="text-center py-4">
              <Spinner animation="border" />
            </div>
          ) : (
            challan && (
              <>
                <div className="card mb-3">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-3">
                        <strong>Challan No:</strong> {challan.Challan_No}
                      </div>
                      <div className="col-md-3">
                        <strong>Student:</strong> {challan.Student_Name}
                      </div>
                      <div className="col-md-2">
                        <strong>Reg No:</strong> {challan.Registration_No}
                      </div>
                      <div className="col-md-2">
                        <strong>Status:</strong>{" "}
                        {challan.Is_Paid ? "Paid" : "Unpaid"}
                      </div>
                      <div className="col-md-2">
                        <strong>Ref Type:</strong> {challan.Reference_ID_Type || "—"}
                      </div>
                    </div>
                    <div className="row mt-2">
                      <div className="col-md-3">
                        <strong>Head Due Amount:</strong> {challan.Due_Date_Amount}
                      </div>
                      <div className="col-md-3">
                        <strong>Head After Due Amount:</strong>{" "}
                        {challan.After_Due_Date_Amount}
                      </div>
                      <div className="col-md-3">
                        <strong>Ledger Total:</strong> {ledgerTotal}
                      </div>
                      <div className="col-md-3">
                        <strong>Edit Total:</strong> {editTotal.toFixed(2)}
                      </div>
                    </div>
                    <div className="row mt-2">
                      <div className="col-md-3">
                        <label className="form-label">Due Date</label>
                        <input
                          type="date"
                          className="form-control"
                          value={dueDate}
                          onChange={(e) => setDueDate(e.target.value)}
                        />
                      </div>
                      <div className="col-md-3">
                        <label className="form-label">After Due Date</label>
                        <input
                          type="date"
                          className="form-control"
                          value={afterDueDate}
                          onChange={(e) => setAfterDueDate(e.target.value)}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="card mb-3">
                  <div className="card-body table-wrap">
                    <h6 className="mb-2">Existing values (read-only)</h6>
                    <div className="table-responsive">
                      <table className="table table-theme table-sm">
                        <thead>
                          <tr>
                            {COLUMNS.map((col) => (
                              <th key={col.key} className="text-nowrap small">
                                {col.label}
                              </th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {originalItems.map((row, index) => (
                            <tr key={`orig-${row.ID || index}`}>
                              {COLUMNS.map((col) => (
                                <td key={col.key} className="small text-nowrap">
                                  {formatDisplay(row, col.key)}
                                </td>
                              ))}
                            </tr>
                          ))}
                          {originalItems.length === 0 && (
                            <tr>
                              <td colSpan={COLUMNS.length} className="text-center text-muted">
                                No ledger rows.
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <div className="card">
                  <div className="card-body table-wrap">
                    <h6 className="mb-2">Edit values</h6>
                    <div className="table-responsive">
                      <table className="table table-theme table-sm">
                        <thead>
                          <tr>
                            {COLUMNS.map((col) => (
                              <th key={col.key} className="text-nowrap small">
                                {col.label}
                              </th>
                            ))}
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          {items.map((row, index) =>
                            row.Is_Deleted ? null : (
                              <tr key={row.ID || `new-${index}`}>
                                {COLUMNS.map((col) => (
                                  <td key={col.key} style={{ minWidth: col.type === "text" ? 120 : 100 }}>
                                    {renderEditCell(row, index, col)}
                                  </td>
                                ))}
                                <td>
                                  <button
                                    type="button"
                                    className="button button-danger button-sm"
                                    onClick={() => handleRemoveRow(index)}
                                  >
                                    Remove
                                  </button>
                                </td>
                              </tr>
                            )
                          )}
                          {activeItems.length === 0 && (
                            <tr>
                              <td colSpan={COLUMNS.length + 1} className="text-center text-muted">
                                No rows. Add a fee head below.
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>

                    <div className="d-flex justify-content-between align-items-center mt-2">
                      <button
                        type="button"
                        className="button button-secondary"
                        onClick={handleAddRow}
                      >
                        Add Fee Head
                      </button>
                      <div>
                        <strong>Receiveable total: </strong>
                        {editTotal.toFixed(2)}
                      </div>
                    </div>

                    <div className="text-end mt-3">
                      <button
                        type="button"
                        className="button button-primary"
                        onClick={handleSave}
                        disabled={saving}
                      >
                        {saving ? "Saving…" : "Save Changes"}
                      </button>
                    </div>
                  </div>
                </div>
              </>
            )
          )}
        </div>
      </div>
    </>
  );
};

export default AdminEditChallan;
